var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.571,
    height: 26.009,
    viewBox: "0 0 30.571 26.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1082",
    "data-name": "Groupe 1082",
    transform: "translate(183.304 -978.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11052",
    "data-name": "Trac\\xE9 11052",
    d: "M-153.232,999.455h-29.573a.538.538,0,0,1-.5-.571V978.707a.538.538,0,0,1,.5-.571h29.573a.538.538,0,0,1,.5.571v20.177A.538.538,0,0,1-153.232,999.455Zm-29.074-1.142h28.576V979.277h-28.576Z",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11053",
    "data-name": "Trac\\xE9 11053",
    d: "M-154.717,1022.328h-6.616a.27.27,0,0,1-.228-.411,6.906,6.906,0,0,0,1.027-4.279h5.013a7.123,7.123,0,0,0,1.032,4.281A.269.269,0,0,1-154.717,1022.328Z",
    transform: "translate(-9.99 -18.183)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11054",
    "data-name": "Trac\\xE9 11054",
    d: "M-182.38,1010.824v3.137h29.573v-3.137Zm14.787,2.268a.463.463,0,0,1-.444-.48.463.463,0,0,1,.444-.48.463.463,0,0,1,.444.48A.463.463,0,0,1-167.593,1013.092Z",
    transform: "translate(-0.425 -15.046)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1081",
    "data-name": "Groupe 1081",
    transform: "translate(-178.947 981.365)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 2.717,
    height: 5.547,
    rx: 1,
    transform: "translate(0 7.25)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708",
    "data-name": "Rectangle 1708",
    width: 2.717,
    height: 7.168,
    rx: 1,
    transform: "translate(3.828 5.63)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    "data-name": "Rectangle 1709",
    width: 2.717,
    height: 3.993,
    rx: 1,
    transform: "translate(7.656 8.805)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 2.717,
    height: 9.056,
    rx: 1,
    transform: "translate(11.485 3.742)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 2.717,
    height: 7.909,
    rx: 1,
    transform: "translate(15.313 4.888)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 2.717,
    height: 5.815,
    rx: 1,
    transform: "translate(19.141 6.982)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11055",
    "data-name": "Trac\\xE9 11055",
    d: "M-172.866,989.806l-.281-.461,4.055-2.474,3.779,2.107,3.819-4.183,7.837,3.75-.233.487-7.476-3.577-3.837,4.2-3.877-2.162Z",
    transform: "translate(174.272 -984.43)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 0.695,
    cy: 0.695,
    r: 0.695,
    transform: "translate(4.491 2.058)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 0.695,
    cy: 0.695,
    r: 0.695,
    transform: "translate(8.319 4.193)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 0.695,
    cy: 0.695,
    r: 0.695,
    transform: "translate(12.147)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 0.695,
    cy: 0.695,
    r: 0.695,
    transform: "translate(19.649 3.571)",
    fill: "#ffc43e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 0.695,
    cy: 0.695,
    r: 0.695,
    transform: "translate(0.57 4.45)",
    fill: "#ffc43e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCourse);
export default __webpack_public_path__ + "static/media/data_course.a6c0bff1c4567af7c2d7585d0be74282.svg";
export { ForwardRef as ReactComponent };